import React from "react";

// reactstrap components
import {
  Container,
} from "reactstrap";


// core components
import ColorNavbar from "components/Navbars/ColorNavbar.js";
import AboutUsHeader from "components/Headers/AboutUsHeader.js";
import styled from "styled-components"

const StyledDiv = styled.div`
  p{
    font-weight: 400;
    font-size: 1rem;
    color: #FFF;
  }
  h3 {
    color: #ffde59;
    font-weight: 450;
  }
  .title-uppercase {
    text-align: center;
    margin-bottom: 0;
  }
  h3, p {
    background-color: #29474a;
    padding: 2rem;
    border-radius: 10px;
  }
`

function AboutUs() {
  document.documentElement.classList.remove("nav-open");

  return (
    <>
      <ColorNavbar />
      <AboutUsHeader />
      <div className="main">
        <div className="section-dark">
          <Container style={{ maxWidth: "80%" }}>
            <StyledDiv>
              <h3 className="title-uppercase">Who are we</h3>
              <br />
              <p>
                A consortium with its morals is what makes it unique; we at <b>SMART EVENT AND PRODUCTION</b>, 
                an event production management company based in DOHA, QATAR express these beliefs to create an 
                atmosphere that yields results and accomplishment. <br /><br />
                <b>SMART EVENT AND PRODUCTION</b> expertise in providing extensive staging, lighting and audio set up 
                solution that matches and exceeds expectation while providing optimum series to clientele. <br /><br />
                In addition, we offer turnkey services in Event Production, Event Planning, Exhibition Design + Building 
                and any woodcraft related, Vendor Management, Consultation and many more. <br /><br />
                Our experienced Event Team will work with you to ensure your event is a complete success on every level. <br />
              </p>

              <h3 className="title-uppercase">
                Founder {`&`} CEO Message
            </h3>
              <br />
              <p>
                "Have a passion for events. This industry can be exhausting, and your passion for the industry is what will keep you on top. Believe in your ideas and strategize to make them come into fruition." <br />
                <i style={{ color: "#ffde59" }}>-Rabih Al maila</i>
              </p>
            </StyledDiv>
          </Container>
          <br />

        </div>
      </div>
    </>

  );
}

export default AboutUs;
